module.exports = __webpack_public_path__ + "media/tycho2t3_80_grey_mz.d0716373.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/sky_box/tycho2t3_80_grey_mz.jpg
// module id = 1100
// module chunks = 0